import { g, Tool } from '@hcie/core';
import { drawLine, drawCircle, drawRect, drawRoundedRect, drawEllipse, moveSelectionContent, moveSelectionMask } from '@hcie/tools';
import { getActiveLayer } from '../layers';
import { tempCtx } from '../rendering-loop';

export class VectorToolsHandler {
    static handleMouseDown(e: MouseEvent): boolean {
        const id = g.current_tool.id;
        const activeLayer = getActiveLayer();
        if (!activeLayer || !activeLayer.visible) return false;

        if ([Tool.MoveSelection.id, Tool.MoveContent.id].includes(id)) {
            if (g.isSelectionActive && g.selectionCanvas) {
                g.movingSelection = true;
                if (id === Tool.MoveContent.id && typeof moveSelectionContent === 'function') {
                    moveSelectionContent(0, 0);
                }
                return true;
            }
            return false;
        }

        const isVectorTool = [
            Tool.Line.id, Tool.Circle.id, Tool.Rectangle.id, 
            Tool.Rounded_Rectangle.id, Tool.Ellipse.id
        ].includes(id);

        if (isVectorTool) {
            // UX: warn when drawing vector tools onto raster layers (still allowed).
            if (activeLayer.type !== 'vector') {
                (window as any).tooltipManager?.showWarning?.('Vector Tool on Raster Layer');
            }
            g.drawing = true;
            console.log(`[DEBUG 2026-04-07][TaskID: Vector] Shape Down startX=${Math.round(g.startX)}, startY=${Math.round(g.startY)}`);
            return true;
        }

        if (id === Tool.Crop.id) {
            this.handleCropMouseDown();
            return true;
        }

        return false;
    }

    private static handleCropMouseDown() {
        const r = (g as any).lastCropRect;
        if (!r) return;
        const s = 15;
        const handles = [
            {x: r.x, y: r.y}, {x: r.x + r.w/2, y: r.y}, {x: r.x + r.w, y: r.y},
            {x: r.x, y: r.y + r.h/2}, {x: r.x + r.w, y: r.y + r.h/2},
            {x: r.x, y: r.y + r.h}, {x: r.x + r.w/2, y: r.y + r.h}, {x: r.x + r.w, y: r.y + r.h}
        ];
        let hIdx = -1;
        for (let i = 0; i < handles.length; i++) {
            if (Math.abs(g.pX - handles[i].x) < s && Math.abs(g.pY - handles[i].y) < s) {
                hIdx = i; break;
            }
        }
        if (hIdx !== -1) {
            (g as any)._isResizingCrop = true;
            (g as any)._cropResizeHandle = hIdx;
            (g as any)._cropRefRect = { ...r };
        } else if (g.pX >= r.x && g.pX <= r.x + r.w && g.pY >= r.y && g.pY <= r.y + r.h) {
            (g as any)._isMovingCrop = true;
            (g as any)._cropRefRect = { ...r };
        }
    }

    static handleMouseMove(e: MouseEvent): boolean {
        const id = g.current_tool.id;
        const isVectorTool = [
            Tool.Line.id, Tool.Circle.id, Tool.Rectangle.id, 
            Tool.Rounded_Rectangle.id, Tool.Ellipse.id
        ].includes(id);

        if (!isVectorTool && !(g as any)._isResizingCrop && !(g as any)._isMovingCrop && !g.movingSelection) return false;
        if (!g.drawing && !(g as any)._isResizingCrop && !(g as any)._isMovingCrop && !g.movingSelection) return false;
        
        const activeLayer = getActiveLayer();
        if (!activeLayer || !activeLayer.ctx) return false;

        const tCtx = tempCtx as CanvasRenderingContext2D;
        if (tCtx) tCtx.clearRect(0, 0, tCtx.canvas.width, tCtx.canvas.height);

        // Move Selection / Move Content tools
        if (g.movingSelection && (id === Tool.MoveSelection.id || id === Tool.MoveContent.id)) {
            const dx = Math.round(g.pX - g.startX);
            const dy = Math.round(g.pY - g.startY);
            if (dx !== 0 || dy !== 0) {
                if (id === Tool.MoveContent.id && typeof moveSelectionContent === 'function') {
                    moveSelectionContent(dx, dy);
                } else if (id === Tool.MoveSelection.id && typeof moveSelectionMask === 'function') {
                    moveSelectionMask(dx, dy);
                    // Keep ghost edit handles aligned if in edit mode
                    if ((g as any)._selectionEditBounds) {
                        const b = (g as any)._selectionEditBounds;
                        b.x1 += dx; b.x2 += dx; b.y1 += dy; b.y2 += dy;
                    }
                }
                g.startX = g.pX;
                g.startY = g.pY;
            }
            return true;
        }

        if (id === Tool.Line.id) {
            drawLine(e, tCtx);
            return true;
        }
        if (id === Tool.Rectangle.id) {
            drawRect(tCtx, g.startX, g.startY, g.pX, g.pY);
            return true;
        }
        if (id === Tool.Circle.id) {
            drawCircle(e, tCtx);
            return true;
        }
        if (id === Tool.Rounded_Rectangle.id) {
            drawRoundedRect(tCtx, g.startX, g.startY, g.pX, g.pY);
            return true;
        }
        if (id === Tool.Ellipse.id) {
            drawEllipse(tCtx, g.startX, g.startY, g.pX, g.pY);
            return true;
        }
        return false;
    }
}
